import { FC } from 'react';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import { useTranslation } from 'react-i18next';
interface ButtonRefreshProps {
  onRefresh: (() => void) | Array<() => void>;
}

const ButtonRefresh: FC<ButtonRefreshProps> = ({ onRefresh }) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (Array.isArray(onRefresh)) {
      onRefresh.forEach(fn => fn && fn());
    } else {
      onRefresh?.();
    }
  };

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tooltip-refresh">{t('refresh')}</Tooltip>}
    >
      <div>
        <Button variant="hover" onClick={handleClick}>
          <FeatherIcon icon="rotate-ccw" />
        </Button>
      </div>
    </OverlayTrigger>
  );
};
export default ButtonRefresh;

//  <ButtonRefresh onRefresh={() => refetch()} />

//  <ButtonRefresh onRefresh={[refetchSettings, refetchActive, refetchNotActive]} />

//  <ButtonRefresh onRefresh={() => queryClient.refetchQueries('GET_ORDER_OUT_MAIN')} />

//  <ButtonRefresh
//    onRefresh={() => {
//      queryClient.refetchQueries('GET_INSTALLMENT_CLIENT');
//      queryClient.refetchQueries('GET_INSTALLMENT_STATUS');
//    }}
//  />
